module.exports = "<span class=\"geo-arrow\"></span>\n<svg><use xlink:href='../../assets/images/icons/icons.svg#icon-obrigacoes'/></svg>\n<span>Obrigações</span>\n<div class=\"geo-submenu\">\n    <a class=\"geo-submenu__item\" [routerLink]=\"['./' + despachosRoute + '/' + obrigacoesRoute]\" routerLinkActive=\"active\" [routerLinkActiveOptions]=\"{ exact: true }\">{{obrigacoesModule.plural}}</a>\n    <a class=\"geo-submenu__item\" [routerLink]=\"['./' + despachosRoute + '/' + obrigacoesRoute + '/' + configuracaoRoute]\" routerLinkActive=\"active\">{{configuracaoModule.plural}}</a>\n</div>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/despachos/shared/despacho-obrigacoes-menu/despacho-obrigacoes-menu.component.html
 ** module id = 1036
 ** module chunks = 0
 **/